import { useNode } from '@craftjs/core';

import SelectProperty from '@/components/builder/properties/Select';

export default function VariantSelectProperty({ ...props }) {
  const { actions: { setProp } } = useNode()

  return <SelectProperty {...props}
    onChange={({ props }) => {
      setProp(prop => {
        Object.assign(prop.properties, props)
      })
    }}
  />
}
